// Copyright Exafunction, Inc.
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file exa/browser_preview_pb/browser_preview.proto (package exa.browser_preview_pb, syntax proto3)
/* eslint-disable */
// @ts-nocheck
// Defines the protocol for the browser preview integration script to communicate with the
// language server.
import { CaptureAllTextRequest, CaptureAllTextResponse, CaptureClickEventRequest, CaptureClickEventResponse, CaptureCodeBlockRequest, CaptureCodeBlockResponse, CaptureConsoleOutputRequest, CaptureConsoleOutputResponse, CaptureDOMElementRequest, CaptureDOMElementResponse, CaptureDOMTreeRequest, CaptureDOMTreeResponse, CaptureElementInnerTextRequest, CaptureElementInnerTextResponse, CaptureElementScreenshotRequest, CaptureElementScreenshotResponse, CaptureLogBlockRequest, CaptureLogBlockResponse, CapturePageContentsRequest, CapturePageContentsResponse, CapturePageMetadataRequest, CapturePageMetadataResponse, CapturePageScreenshotRequest, CapturePageScreenshotResponse, CaptureScreenshotRequest, CaptureScreenshotResponse, CaptureScrollEventRequest, CaptureScrollEventResponse, CaptureSelectedTextRequest, CaptureSelectedTextResponse, ClickPixelRequest, ClickPixelResponse, ExecuteJavaScriptRequest, ExecuteJavaScriptResponse, GetBrowserInstallationStatusRequest, GetBrowserInstallationStatusResponse, ListPagesRequest, ListPagesResponse, NavigateToURLRequest, NavigateToURLResponse, RecordBrowserAnalyticsRequest, RecordBrowserAnalyticsResponse, RegisterPageRequest, RegisterPageResponse, SendConsoleOutputRequest, SendConsoleOutputResponse, SendDOMElementRequest, SendDOMElementResponse, SendScreenshotRequest, SendScreenshotResponse, StartBrowserRequest, StartBrowserResponse, StopBrowserRequest, StopBrowserResponse } from "./browser_preview_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Service for the in-IDE browser preview functionalities (via proxy server)
 *
 * @generated from service exa.browser_preview_pb.BrowserPreviewService
 */
export const BrowserPreviewService = {
    typeName: "exa.browser_preview_pb.BrowserPreviewService",
    methods: {
        /**
         * @generated from rpc exa.browser_preview_pb.BrowserPreviewService.SendDOMElement
         */
        sendDOMElement: {
            name: "SendDOMElement",
            I: SendDOMElementRequest,
            O: SendDOMElementResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.BrowserPreviewService.SendScreenshot
         */
        sendScreenshot: {
            name: "SendScreenshot",
            I: SendScreenshotRequest,
            O: SendScreenshotResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.BrowserPreviewService.SendConsoleOutput
         */
        sendConsoleOutput: {
            name: "SendConsoleOutput",
            I: SendConsoleOutputRequest,
            O: SendConsoleOutputResponse,
            kind: MethodKind.Unary,
        },
    }
};
/**
 * Playwright browser service that handles all browser functionalities
 *
 * @generated from service exa.browser_preview_pb.WindsurfBrowserService
 */
export const WindsurfBrowserService = {
    typeName: "exa.browser_preview_pb.WindsurfBrowserService",
    methods: {
        /**
         * Browser control RPCs - Between Chat Client and Language Server
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.StartBrowser
         */
        startBrowser: {
            name: "StartBrowser",
            I: StartBrowserRequest,
            O: StartBrowserResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.StopBrowser
         */
        stopBrowser: {
            name: "StopBrowser",
            I: StopBrowserRequest,
            O: StopBrowserResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Browser metadata RPCs
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.GetBrowserInstallationStatus
         */
        getBrowserInstallationStatus: {
            name: "GetBrowserInstallationStatus",
            I: GetBrowserInstallationStatusRequest,
            O: GetBrowserInstallationStatusResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.ListPages
         */
        listPages: {
            name: "ListPages",
            I: ListPagesRequest,
            O: ListPagesResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Injected script RPCs - Between Browser and Language Server
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.NavigateToURL
         */
        navigateToURL: {
            name: "NavigateToURL",
            I: NavigateToURLRequest,
            O: NavigateToURLResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureDOMElement
         */
        captureDOMElement: {
            name: "CaptureDOMElement",
            I: CaptureDOMElementRequest,
            O: CaptureDOMElementResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureScreenshot
         */
        captureScreenshot: {
            name: "CaptureScreenshot",
            I: CaptureScreenshotRequest,
            O: CaptureScreenshotResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureElementScreenshot
         */
        captureElementScreenshot: {
            name: "CaptureElementScreenshot",
            I: CaptureElementScreenshotRequest,
            O: CaptureElementScreenshotResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureConsoleOutput
         */
        captureConsoleOutput: {
            name: "CaptureConsoleOutput",
            I: CaptureConsoleOutputRequest,
            O: CaptureConsoleOutputResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureAllText
         */
        captureAllText: {
            name: "CaptureAllText",
            I: CaptureAllTextRequest,
            O: CaptureAllTextResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureSelectedText
         */
        captureSelectedText: {
            name: "CaptureSelectedText",
            I: CaptureSelectedTextRequest,
            O: CaptureSelectedTextResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureCodeBlock
         */
        captureCodeBlock: {
            name: "CaptureCodeBlock",
            I: CaptureCodeBlockRequest,
            O: CaptureCodeBlockResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureLogBlock
         */
        captureLogBlock: {
            name: "CaptureLogBlock",
            I: CaptureLogBlockRequest,
            O: CaptureLogBlockResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureClickEvent
         */
        captureClickEvent: {
            name: "CaptureClickEvent",
            I: CaptureClickEventRequest,
            O: CaptureClickEventResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureScrollEvent
         */
        captureScrollEvent: {
            name: "CaptureScrollEvent",
            I: CaptureScrollEventRequest,
            O: CaptureScrollEventResponse,
            kind: MethodKind.Unary,
        },
        /**
         * CaptureElementInnerText captures the inner text content of a specific DOM element
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureElementInnerText
         */
        captureElementInnerText: {
            name: "CaptureElementInnerText",
            I: CaptureElementInnerTextRequest,
            O: CaptureElementInnerTextResponse,
            kind: MethodKind.Unary,
        },
        /**
         * CapturePageContents captures the structured contents of a web page, including its title, description, and text elements.
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CapturePageContents
         */
        capturePageContents: {
            name: "CapturePageContents",
            I: CapturePageContentsRequest,
            O: CapturePageContentsResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Capture page metadata gets the metadata associated with a Playwright controlled Browser page.
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CapturePageMetadata
         */
        capturePageMetadata: {
            name: "CapturePageMetadata",
            I: CapturePageMetadataRequest,
            O: CapturePageMetadataResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Execute JavaScript in the Browser by the page ID.
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.ExecuteJavaScript
         */
        executeJavaScript: {
            name: "ExecuteJavaScript",
            I: ExecuteJavaScriptRequest,
            O: ExecuteJavaScriptResponse,
            kind: MethodKind.Unary,
        },
        /**
         * CapturePageScreenshot - captures screenshot and returns img data in response.
         * Note this is different from CaptureScreenshot/CaptureElementScreenshot which return img data via chatbridge (with implication that the user is the actor, not Cascade).
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CapturePageScreenshot
         */
        capturePageScreenshot: {
            name: "CapturePageScreenshot",
            I: CapturePageScreenshotRequest,
            O: CapturePageScreenshotResponse,
            kind: MethodKind.Unary,
        },
        /**
         * ClickPixel - clicks at a specific pixel coordinate on a browser page.
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.ClickPixel
         */
        clickPixel: {
            name: "ClickPixel",
            I: ClickPixelRequest,
            O: ClickPixelResponse,
            kind: MethodKind.Unary,
        },
        /**
         * CaptureDOMTree - captures the DOM tree structure of a browser page.
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.CaptureDOMTree
         */
        captureDOMTree: {
            name: "CaptureDOMTree",
            I: CaptureDOMTreeRequest,
            O: CaptureDOMTreeResponse,
            kind: MethodKind.Unary,
        },
        /**
         * RegisterPage registers a new page with the browser service when it's opened by the extension
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.RegisterPage
         */
        registerPage: {
            name: "RegisterPage",
            I: RegisterPageRequest,
            O: RegisterPageResponse,
            kind: MethodKind.Unary,
        },
        /**
         * RecordBrowserAnalytics records comprehensive browser analytics for detailed insights
         *
         * @generated from rpc exa.browser_preview_pb.WindsurfBrowserService.RecordBrowserAnalytics
         */
        recordBrowserAnalytics: {
            name: "RecordBrowserAnalytics",
            I: RecordBrowserAnalyticsRequest,
            O: RecordBrowserAnalyticsResponse,
            kind: MethodKind.Unary,
        },
    }
};
